<template>
    <div id="backdropConfig">
        <splash-mini :time="126000" v-if="automaticLog"></splash-mini>
        <img :src="cover" class="coverImg">
        <span class="cover"></span>
        <div id="modalConfigForm" class="col-10 col-lg-7 pt-2">
            <div class="w-100 mt-1 textError d-flex justify-content-center align-items-center align-content-center">
            </div>

            <div class="d-flex w-100 px-5 align-items-center align-content-center mb-3">
                <div class="d-flex px-0 align-items-center justify-content-end align-content-center text-end text w-30 m-0 pe-2">
                    Usuario
                </div>
    
                <div class="d-flex justify-content-center align-items-center align-content-center w-70">
                    <input type="text" :class="error ? 'err' : ''" class="input-config mx-2 px-2" style="width:100%" placeholder="sucursal" v-model="user" autocorrect="off" autocapitalize="off">
                </div>
            </div>

            <div class="d-flex w-100 px-5 align-items-center align-content-center">
                <div class="d-flex px-0 align-items-center justify-content-end  align-content-center mt-3 text w-30 text-end pe-2 pb-3">
                    Contraseña
                </div>
    
                <div class="d-flex justify-content-start align-items-center align-content-center w-70">
                    <input :type="passType ? 'text' : 'password'" :class="error ? 'err' : ''" class="input-config mx-2 px-2" style="width:100%" placeholder="contraseña" v-model="pass">
                </div>
            </div>

            <div v-if="error" class="w-100 d-flex justify-content-center align-items-center align-content-center mb-1 textError mt-3">
                Usuario y Contraseña inválidos
            </div>
           
            <div class="w-100 d-flex justify-content-center align-items-center align-content-center mb-5">
                <button @click="getConfig()" class="btn-config w-50">Entrar</button>
                <button @click="seePass()" class="btn-config px-4 ms-3">Ver contraseña</button>
            </div>

            <div class="radio-group mb-4">
                <label :class="selectedOption == 'local' ? 'selected' : ''" class="radio-button">
                  <input
                    type="radio"
                    value="local"
                    v-model="selectedOption"
                  />
                  Local
                </label>
                <label :class="selectedOption == 'production' ? 'selected' : ''" class="radio-button">
                  <input
                    type="radio"
                    value="production"
                    v-model="selectedOption"
                  />
                  Producción
                </label>
              </div>
        </div>
    </div>
</template>

<script>

import axios from "axios";
import splashMini from "@/components/common/SplashMini.vue";

export default {
    name:"getConfig",
    emits:['setAccessKeys'],
    components:{
        splashMini
    },
    methods:{
        seePass(){
            this.passType = this.passType ? false : true;
        },
        getConfig(){
            this.error = false;
            this.logIn().then((configData)=>{
                if(configData){
                    localStorage.setItem('appConfigCRM', JSON.stringify(configData));
                    this.$emit('setAccessKeys', {access:true, appConfigCRM:configData});
                }
                else{
                    this.error = true;
                    localStorage.removeItem('appConfigCRM');
                }
            });  
        },

        reload(){
            document.location.href="/";
        },

        logIn(logCredientials=false){

            return new Promise((resolve) => {

                const crypto = require("crypto");
                let credentials = {};

                if(!logCredientials){
                    const login = crypto
                        .createHash("md5")
                        .update(this.user.trim())
                        .digest("hex");
                    const loginSha = crypto
                        .createHash("sha1")
                        .update(login)
                        .digest("hex");
                    const password = crypto
                        .createHash("md5")
                        .update(this.pass.trim())
                        .digest("hex");
                    const passwordSha = crypto
                        .createHash("sha1")
                        .update(password)
                        .digest("hex");

                    credentials = {
                        "login": loginSha,
                        "password": passwordSha,
                        "apiDir": this.selectedOption
                    };
                }else{
                    credentials = logCredientials;
                }

                axios.post((this.selectedOption == 'local' ? this.apiMotherLocal : this.apiMotherProduction) + "Terminal/login", credentials, null).then((response) => {
                    try{
                        if(response.data.code == 200){
                            localStorage.setItem('creds', JSON.stringify(credentials))
                            resolve( response.data.data)
                        }else{
                            resolve(
                                false
                            )
                        }
                    }catch(err){

                    }
				}).catch( (error) => {
                    resolve(
                        false
                    )
				});
                /*if(this.user == "local" && this.pass=="123"){
                    import(`@/assets/json/local.json`).then((config) => {
                        import(`@/assets/json/localTables.json`).then((tableList) => {
                            resolve( {"config":config, "tables":tableList} )
                        })
                    });
                   
                }else if(this.user == "6001" && this.pass=="123"){
                    import(`@/assets/json/6001.json`).then((config) => {
                        import(`@/assets/json/6001Tables.json`).then((tableList) => {
                            resolve( {"config":config, "tables":tableList} )
                        })
                    });
                   
                }else{
                    resolve(
                        false
                    )
                }*/
            })
        },

    },
    data(){
        return{
            automaticLog:localStorage.creds ? true : false,
            passType:false,
            error:false,
            selectedOption: 'production',
            cover: require("@/assets/images/a31.gif"),
            user:"",
            pass:"",
            apiMotherLocal: "https://mikele.efisen.se/apiCRM/",
            apiMotherProduction: "https://ap15.efisense.net/apiCRM/",
        }
    }, 
    mounted(){
        if(localStorage.creds){
            let creds = JSON.parse(localStorage.creds);
            this.selectedOption = creds.apiDir;
            this.logIn(creds).then((configData)=>{
                if(configData){
                    localStorage.setItem('appConfigCRM', JSON.stringify(configData));
                    this.$emit('setAccessKeys', {access:true, appConfigCRM:configData});
                }else{
                    this.automaticLog = false;
                }
            });
        }
    },
}
</script>

<style scoped>
    .text{
       color: var(--contrast1);
       font-weight: bold;
    }

    #backdropConfig{
        z-index: 4000;
        position: fixed;
        display: flex;
        justify-content: center;
        align-items: center;
        align-content:center;
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0;
        user-select: none;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
    }

    .coverImg{
        position: absolute; 
        z-index: 4001;  
        width: 100%;
        height: 100%;
        object-fit: cover;
        opacity: 0.5;
    }

    .textError{
        font-size: 18px;
        color: #ff0000;
        font-weight: bold;
        height: 30px; 
    }




    #modalConfigForm{
        background-color: var(--tertiary);
        max-width: 750px;
        min-height: 250px;
        height: auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        align-content: center;
        z-index: 4002;
        border-radius: 4px;
    }

    .input-config{
        border-radius: 4px;
        outline: none;
        border: 2px solid #ccc;
        height: 50px;
    }

    .input-config.err{
        border: 2px solid var(--quinary) !important; 
    }



    .input-config:active, .input-config:focus{
        border: 2px solid var(--primary);
    }

    .btn-config{
        background-color: var(--primary);
        color: #fff;
        padding: 7px 15px 9px 15px;
        height: 55px;
        line-height: 1.2em;
        margin-top: 40px;
        border-radius: 4px;
        outline: none !important;
        border: 0 !important;
        font-weight: bold;
        overflow:hidden
    }

    .btn-config:hover{
        background-color: var(--quartenary);
    }

    .w-70{
        width: 70% !important;
    }
    .w-30{
        width: 30% !important;
    }
    .cover{
        position: fixed;
        left: 0;
        top: 0;
        width: 100vw;
        height:100vh;
        backdrop-filter: blur(25px);
        z-index: 4002;
    }

    .radio-group {
        display: flex;
        justify-content: center;
        gap: 10px;
      }
      
      .radio-button {
        display: inline-block;
        padding: 10px 20px;
        border: 2px solid #ccc;
        border-radius: 5px;
        cursor: pointer;
        user-select: none;
        background-color: #f9f9f9;
        transition: background-color 0.3s, border-color 0.3s;
      }
      
      .radio-button.selected {
        background-color: #007bff !important;
        color: white;
        border-color: #007bff;
      }
      
      .radio-button input {
        display: none;
      }
      
      .radio-button:hover {
        background-color: #e0e0e0;
      }


</style>